import { Injectable } from '@angular/core';
import DomainEventProvider from 'src/app/core/domain/events/domain_event_provider';

import { TrackerEvent } from './tracker_events';

@Injectable({ providedIn: 'root' })
export class TrackerEventProvider extends DomainEventProvider<TrackerEvent> {}
